module.exports = __webpack_public_path__ + "img/icon_nodata.afecb23d.png";